import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { SharedAlertModelComponent } from 'src/app/common-shared-modules/shared-alert-model/shared-alert-model.component';
import { Constant } from 'src/app/helpers/constants/constant';
import { LocalserviceService } from 'src/app/helpers/services/localservice.service';

@Component({
  selector: 'app-group-renew-dropout',
  templateUrl: './group-renew-dropout.component.html',
  styleUrls: ['./group-renew-dropout.component.css']
})
export class GroupRenewDropoutComponent implements OnInit {

  constructor(
    public appservice: LocalserviceService,
    private activatedRoute: ActivatedRoute,
    public matDialog: MatDialog,
  ) { }

  dropoutId = '';

  fetechDataResponse;

  ngOnInit(): void {

    this.activatedRoute.queryParams.subscribe(params => {

      this.dropoutId = params['grid'];
      this.fetchData();

    });

  }

  fetchData() {
    var header = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    };
    console.log(this.dropoutId)
    this.appservice.show();
    var dropOutRequest = { "tblName": "group-renew-dropout", "transId": this.dropoutId }
    this.appservice.PostApi(Constant.hservice_base_url + 'RenewalPolicy/fetchData', dropOutRequest, header).subscribe(res => {
      console.log(res)
      if (res.code == 1) {
        this.fetechDataResponse = res.data[0];
        this.onSubmit();
      }


      //window.location.href = res.ResponseData;
    })

  }

  onSubmit() {



    // this.messageObj = {
    //   "messageVal": "Success",
    //   "classVal": "s",
    //   "showAlertSwipe": true
    // }

    // this.alertSwipe.sliderAlertSwipe(this.messageObj);

    // const alertModel = new MatDialogConfig();
    // alertModel.disableClose = true;
    // alertModel.id = "modal-component";
    // alertModel.height = "245px";
    // alertModel.width = "480px";
    // alertModel.data = {

    //   title: "Alert Model",
    //   description: "Contect to be displayed",
    //   successText: "OK",
    //   failureText: "cancel",
    //   showSuccessBtn : true,
    //   showFaliureBtn : true,

    // }
    // https://material.angular.io/components/dialog/overview
    // const modalDialog = this.matDialog.open( SharedAlertModelComponent , alertModel);
    var loginObj = {
      "LeadID": "",
      "MasterPolicyNumber": "",
      "CertificateNumber": this.fetechDataResponse.COI_Number,
      "DOB": this.fetechDataResponse.Dob,
      "ProposerMobileNumber": this.fetechDataResponse.Mobile
    }


    const headernew = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'x-ob-bypass': Constant.x_ob_bypass,
    };


    this.appservice.PostApi(Constant.hpre_BaseUrl + '/api/groupRenew/CheckRenewDetails', loginObj, headernew).subscribe(res => {
      console.log(res)
      this.appservice.hide()
      if (res.ResponseCode == '1' && res.ResponseData.Policies != null) {
        var policyDetails = res.ResponseData;
        sessionStorage.refNoArray = JSON.stringify(policyDetails.Policies);
        console.log(sessionStorage.refNoArray);
        sessionStorage.setItem('ut', policyDetails.Policies[0].ut);
        window.location.href = 'group-renew-landing';
      } else if (res.ResponseCode == '0' || res.ResponseData.Policies == null) {
        var errorMessage = res.ResponseData != null ? res.ResponseData.ErrorMessage : res.ResponseMessage

        const alertModel = new MatDialogConfig();
        alertModel.disableClose = true;
        alertModel.id = "modal-component";
        alertModel.height = "195px";
        alertModel.width = "550px";
        alertModel.data = {
          title: "Alert Model",
          description: errorMessage,
          successText: "Ok",
          failureText: "Cancel",
          showSuccessBtn: true,
          showFaliureBtn: true,

        }
        const modalDialog = this.matDialog.open(SharedAlertModelComponent, alertModel);
      }

    })
  }



}
